import './index.scss';
import { ModalProps } from '../types';

export const Modal = ({open, children, cancel, className, isOnMenu}: ModalProps) => {
    return (
        <div onClick={cancel} className={`modal-container ${!open ? 'hide': ''} ${isOnMenu ? 'on-menu': ''}`}>
            <div onClick={(e) => e.stopPropagation()} className={`modal-content ${className}`}>
                {children}
            </div>
        </div>
    )
}
